import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { datadogRum } from '@datadog/browser-rum';
import '@mantine/core/styles.css';
import { MantineProvider, createTheme } from '@mantine/core';

console.log("👉 1. Datadog 초기화 시작 전");

try {
  datadogRum.init({
    // 1. [중요] 여기는 원래 주인(Org A)의 ID/Token을 그대로 둡니다.
    applicationId: '5c721f6a-c32e-4406-b643-cd5177e58b13',
    clientToken: 'puba1f632f27a655b6145596cc0062d5cb8',

    site: 'datadoghq.com',
    service: 'cinema-front',
    env: 'test',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',

    // 1. 요청을 추적할 백엔드 API의 URL 패턴을 지정합니다.
    allowedTracingUrls: [
      /https:\/\/server\.gsneotek\.cloud/
    ],
    // 2. 브라우저 요청 중 몇 %를 백엔드 트레이스와 연결할지 설정 (100 = 100%)
    traceSampleRate: 100,
    traceContextInjection: 'all',
    // --- [중요] Trace 연결 설정 끝 ---

  });


  console.log("👉 2. Datadog 초기화 함수 실행 완료");
} catch (e) {
  console.error("🚨 Datadog 초기화 중 에러 발생:", e);
}

const theme = createTheme({
  /** Put your mantine theme override here */
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <App />
    </MantineProvider>
  </React.StrictMode>
);

reportWebVitals();